// extracted by mini-css-extract-plugin
export var deliveryRow = "_t0-a";
export var fixedHeight = "_t0-4";
export var freightLogo = "_t0-9";
export var fullWidth = "_t0-3";
export var priceColumn = "_t0-5";
export var radioSelected = "_t0-7";
export var radioUnselected = "_t0-6";
export var selectedOption = "_t0-2";
export var selectedOptionContainer = "_t0-1";
export var selection = "_t0-0";
export var tallSkeletonText = "_t0-8";